import express, { Router } from 'express';

import * as campaignValidation from './campaign.validation';
import * as campaignController from './campaign.controller';

import { validateMiddleware } from '@/shared/utils/middlewares';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.CAMPAIGN, ACTIONS.READ),
    validateMiddleware(campaignValidation.getCampaigns),
    campaignController.getCampaigns,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.CAMPAIGN, ACTIONS.CREATE),
    validateMiddleware(campaignValidation.createCampaign()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'company' }),
    campaignController.createCampaign,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.CAMPAIGN, ACTIONS.READ),
    validateMiddleware(campaignValidation.getCampaignById),
    campaignController.getCampaignById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.CAMPAIGN, ACTIONS.UPDATE),
    validateMiddleware(campaignValidation.updateCampaign()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    campaignController.updateCampaign,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.CAMPAIGN, ACTIONS.DELETE),
    validateMiddleware(campaignValidation.deleteCampaignById),
    campaignController.deleteCampaignById,
  );

export default router;
